import { MarkerTypeGeneral } from 'types/markerTypes/location-markers-type.js';
import { ISummary } from 'types/markerTypes/location.summary.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { isNotNullOrUndefined } from 'utilities/isType.js';

export const SearchbarFavouriteLocationBody = ({ favourite }: { favourite: ILocationSummary }) => {
  const { type, value } = favourite;
  if (favourite.value) {
    const val = favourite.value as ISummary;
    const { wind, temp } = val;

    if (value) {
      if (type === MarkerTypeGeneral.Coastal) {
        if (wind) {
          return (
            <small className="u-textNoWrap">
              {wind.direction} {wind.averageSpeed || wind.gustSpeed}
              {'kts'}
            </small>
          );
        }
      }
      if (isNotNullOrUndefined(temp)) {
        return <small>{temp}°</small>;
      }
    }
  }

  return null;
};
